module.exports = __webpack_public_path__ + "img/bob.cb64610a.png";